<template>
    <div>
        <!-- <div class="d-flex">
            <div class="mb-3 me-4">
                <label>{{t.blog.post_categories}}</label>
                <select v-model="selectedPostCategory" class="form-select form-select-sm" @change="select()">
                    <option :value="null">{{t.global.all}}</option>
                    <option v-for="postCategory in postCategories" :key="postCategory.id" :value="postCategory.id">{{postCategory.name}}</option>
                </select>
            </div>
            <div class="mb-3">
                <label>{{t.blog.post_types}}</label>
                <select v-model="selectedType" class="form-select form-select-sm" @change="select()">
                    <option :value="null">{{t.global.all}}</option>
                    <option v-for="(type, index) in config.blog.blog_post_types" :key="index" :value="type">{{t.blog[type]}}</option>
                </select>
            </div>
        </div>
        <div v-if="selectedTags.length" class="mb-3">
            <span>{{t.blog.selected_tags}}:</span>
            <span v-for="tag in selectedTags" :key="tag" class="me-2 btn btn-sm btn-outline-secondary py-0" @click="removeTag(tag)"><i class="fa-solid fa-xmark"></i> #{{tag}}</span>
        </div>
        <masonry
            v-if="loaded && posts.length"
            :cols="window.innerWidth <= 420 ? 1 : (window.innerWidth <= 768 ? 2 : 3)"
            :gutter="20"
            tag="div"
            class="post-grid"
        >
            <div class="item mb-3 bg-light" v-for="post in posts" :key="post.id">
                <a v-if="post.type == 'article'" :href="post.url"><img :src="post.thumbnail" class="w-100" :alt="post.title"></a>
                <img v-else-if="post.type != 'video_news'" :src="post.thumbnail" class="w-100" :alt="post.title">
                <iframe
                    v-else
                    style="min-height: 230px; width: 100%"
                    :src="'https://www.youtube.com/embed/'+post.video"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
                <div class="p-3">
                    <div class="small text-muted mb-2"><i class="fa-regular fa-calendar-days"></i> {{post.formattedDate}}</div>
                    <div class="mb-2">
                        <a v-if="post.type == 'article'" class="h5" :href="post.url">{{post.title}}</a>
                        <span v-else class="h5">{{post.title}}</span>
                        <span class="badge rounded-pill bg-secondary fw-normal ms-1" v-if="post.draft">{{t.global.draft}}</span>
                    </div>
                    <div v-if="post.type == 'article'">{{truncateText(stripTags(post.content), 100)}}</div>
                    <div v-else>{{post.content}}</div>
                    <a v-if="post.type == 'article'" class="btn btn-sm btn-link p-0" :href="post.url">{{t.blog.read_more}}</a>
                    <div class="small text-muted mt-2">
                        <span v-for="tag in post.arrayTags" :key="tag" class="me-2 cursor-pointer text-underline" @click="addTag(tag)">#{{tag}}</span>
                    </div>
                </div>
            </div>
        </masonry>
        <div v-else-if="!loaded" class="d-flex justify-content-center align-items-center" style="min-height:417px">
            <div class="spinner-grow text-muted" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-else>
            {{t.blog.no_posts_found}}
        </div> -->
        <div v-if="postCategories && postCategories.length" class="carousel-tabs owl-carousel owl-nav-hover-fixed carousel-widget nav tabs nav-tabs mb-3 carousel-blur-right nav-fill"
            data-pagi="false" data-nav="false" role="tablist">
            <div class="nav-item">
                <button class="nav-link no-outline-btn" :class="{ 'active nav-link no-outline-btn': selectedPostCategory == null }"
                    @click="selectedPostCategory = null; select()" type="button">All post categories</button>
            </div>
            <div class="nav-item" v-for="postCategory in postCategories" :key="postCategory.id">
                <button class="nav-link no-outline-btn" :class="{ 'active no-outline-btn': selectedPostCategory == postCategory.id }"
                    @click="selectedPostCategory = postCategory.id; select()" type="button">{{ postCategory.name }}</button>
            </div>
        </div>
        <div class="carousel-tabs owl-carousel owl-nav-hover-fixed carousel-widget nav tabs nav-tabs mb-3 carousel-blur-right nav-fill"
            data-pagi="false" data-nav="false" role="tablist">
            <div class="nav-item">
                <button class="nav-link no-outline-btn" :class="{ 'active no-outline-btn': selectedType == null }"
                    @click="selectedType = null; select()" type="button">All post types</button>
            </div>
            <div class="nav-item" v-for="blogType in config.blog.blog_post_types" :key="blogType">
                <button class="nav-link no-outline-btn" :class="{ 'active no-outline-btn': selectedType == blogType }"
                    @click="selectedType = blogType; select()" type="button">{{ t.blog[blogType] }}</button>
            </div>
        </div>
        <!-- <div v-if="loaded && posts.length" class="row grid-container gutter-30 mb-5" ref="grid"> -->
        <masonry v-if="loaded && posts.length" :cols="window.innerWidth <= 420 ? 1 : (window.innerWidth <= 768 ? 2 : 3)"
            :gutter="20" tag="div" class="post-grid">
            <div class="item rounded img-hover-wrap mb-4 mt-4" v-for="post in posts" :key="post.id">
                <div class="img-hover-card">
                    <a v-if="post.type == 'article'" class="overlay" :href="post.url">
                        <img :src="post.thumbnail" :alt="post.title" class="w-100 h-auto" width="405" height="400">
                    </a>
                    <a v-else-if="post.type == 'video_news'" target="_blank" class="overlay" :href="post.video" data-lightbox="iframe">
                        <img :src="post.thumbnail" :alt="post.title" class="w-100 h-auto" width="405" height="400">
                    </a>
                    <div v-else class="overlay">
                        <img :src="post.thumbnail" :alt="post.title" class="w-100 h-auto" width="405" height="400">
                    </div>
                    <div class="img-hover-detail">
                        <small class="text-light
                        ls-1 fw-light">{{ t.blog[post.type] }}</small>
                        <h3 v-if="post.type == 'article'" class="img-hover-title">
                            <a :href="post.url">{{ post.title }}</a>
                        </h3>
                        <h3 v-else-if="post.type == 'video_news'" class="img-hover-title">
                            <a href="#" data-hover-animate="op-1" data-hover-animate-out="op-07" class="mb-3 overlay-trigger-icon size-md op-ts op-07 bg-light text-dark"><i class="bi-play-fill fs-2 position-relative" style="left: 1px;"></i></a>
                            {{ post.title }}
                        </h3>
                        <h3 v-else class="img-hover-title">
                            {{ post.title }}
                        </h3>
                        <!-- <div class="text-white">{{ post.date }}</div> -->
                        <div v-if="post.type == 'quick_news'" class="small text-white">
                            {{ post.content }}</div>
                        <a v-if="post.type == 'article'" class="img-link" :href="post.url"><i
                                class="bi-arrow-right"></i> {{ t.blog.learn_more }}</a>
                    </div>
                </div>
            </div>
        </masonry>
        <div v-else-if="!loaded" class="d-flex justify-content-center align-items-center" style="min-height:417px">
            <div class="spinner-grow text-muted" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-else class="pt-5">
            {{ t.blog.no_posts_found }}
        </div>
        <!-- </div> -->
        <div class="d-flex justify-content-center">
            <Bootstrap5Pagination :data="result" @pagination-change-page="getResult" />
        </div>
    </div>
</template>

<script>
import VueMasonry from "vue-masonry-css";
// import InfiniteLoading from "vue-infinite-loading";
import Bootstrap5Pagination from 'laravel-vue-pagination';
export default {
    components: {
        // InfiniteLoading,
        VueMasonry,
        Bootstrap5Pagination,
    },
    data() {
        return {
            window: window,
            config: config,
            t: t,
            postCategories: postCategories,
            page: window.page ? window.page : 1,
            posts: [],
            selectedTags: window.tags ? window.tags : [],
            selectedType: window.type ? window.type : null,
            selectedPostCategory: window.post_category ? window.post_category : null,
            result: {},
            loaded: false,
        }
    },
    mounted() {
        this.getResult(page)
    },
    methods: {
        removeTag(tag) {
            this.selectedTags.splice(this.selectedTags.indexOf(tag), 1)
            this.posts = []
            this.getResult(1)
        },
        addTag(tag) {
            this.selectedTags.push(tag)
            this.posts = []
            this.getResult(1)
        },
        select() {
            this.posts = []
            this.getResult(1)
        },
        getResult(page = 1) {
            this.loaded = false
            axios
                .get("/ajax/posts", {
                    params: {
                        page: page,
                        type: this.selectedType,
                        post_category: this.selectedPostCategory,
                        tags: this.selectedTags,
                    },
                })
                .then(async (response) => {
                    this.result = response.data
                    if (response.data.data.length) {
                        this.posts = response.data.data
                    }
                    this.loaded = true
                    this.changeUrl()
                    this.$nextTick().then(() => {
                        if (typeof CNVS.Lightbox !== 'undefined')
                        CNVS.Lightbox.init('[data-lightbox]')
                    });
                });
        },
        changeUrl() {
            var url = this.url('blog')
            var stringQueries = []
            if (this.selectedPostCategory) {
                stringQueries.push('post_category=' + this.selectedPostCategory)
            }
            if (this.selectedType) {
                stringQueries.push('type=' + this.selectedType)
            }
            if (this.selectedTags.length) {
                stringQueries.push('tags=' + this.selectedTags.join(','))
            }
            if (this.result.current_page > 1) {
                stringQueries.push('page=' + this.result.current_page)
            }
            history.replaceState(
                {},
                null,
                url + (stringQueries.length ? '?' + stringQueries.join('&') : '')
            )
        }
    }
}
</script>
